// Exchange token redemption helper
// Responsible for redeeming ?drkpnk=<exchangeToken> passed from Risk Portal.
// Returns a normalized result { success, token?, error?, raw }
// Flexible JWT key handling: token | jwtToken | jwt
// NOTE: Uses configApi (same base URL already set by runtime settings loader)

// http-client lives one directory up two levels (shared/utils/http-client.js)
// Relative path from admin-portal/shared/utils/api -> shared/utils/http-client.js (two directories up then into shared/utils)
import { configApi } from '../../../../shared/utils/http-client.js'

export async function redeemExchangeToken (exchangeToken) {
	if (!exchangeToken) return { success: false, error: 'missing_token' }
	try {
		const { data } = await configApi.post('/api/admin-portal-microservice/redeem-exchange-token', { token: exchangeToken })
		const jwt = data?.token || data?.jwtToken || data?.jwt
		if ((data?.success === true || !!jwt) && jwt) {
			return { success: true, token: jwt, raw: data }
		}
		return { success: false, error: data?.failureReason || 'redemption_failed', raw: data }
	} catch (err) {
		return { success: false, error: err?.message || 'network_error' }
	}
}
